import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import {
	getEstablishmentList,
	addNewEstablishment,
	updateEstablishment,
	deleteEstablishment,
	getEstablishment,
	getProductiveCycleActive
} from '../establishment/thunk';

export const initialState = {
	itemEstablishmentList: [],
	itemEstablishmentDetail: null,
	isEstablishmentLoading: false,
	isEstablishmentSuccess: false,

	productiveCycleActiveDetail: null,

	establishmentList: [],
	establishmentListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,

	isLoading: false,
	isSuccess: false,
	isError: false,
	error: ""
};

const EstablishmentSlice = createSlice({
	name: 'Establishments',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getEstablishment.fulfilled, (state, action) => {
			state.isEstablishmentLoading = false;
			state.isEstablishmentSuccess = true;
			state.itemEstablishmentDetail = action.payload;
			state.isLoadingList = false;
			
			state.isLoading = false;
			state.isSuccess = true;
		});
		builder.addCase(getEstablishment.pending, state => {
			state.isEstablishmentLoading = true;
			state.isEstablishmentSuccess = null;
			state.error = null;
			state.isLoadingList = true;
			
			state.isLoading = true;
			state.isSuccess = false;
			state.error = null;
		});
		builder.addCase(getEstablishment.rejected, (state, action) => {
			state.isEstablishmentLoading = false;
			state.isEstablishmentSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
			
			state.isLoading = false;
			state.isSuccess = false;
			state.isError = true;
			state.error = action.error.message;
		});

		builder.addCase(getEstablishmentList.pending, state => {
			state.isEstablishmentSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getEstablishmentList.fulfilled, (state, action) => {
			state.itemEstablishmentList = action.payload;
			state.establishmentList = action.payload;
			state.isLoadingList = false;
			state.isEstablishmentSuccess = true;

			let establishmentListSelect = [];
			action.payload.map(item =>
				establishmentListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.establishmentListSelect = establishmentListSelect;
		});
		builder.addCase(getEstablishmentList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isEstablishmentSuccess = true;
		});
		builder.addCase(addNewEstablishment.fulfilled, (state, action) => {
			state.itemEstablishmentList.push(action.payload);
			state.establishmentList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewEstablishment.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewEstablishment.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updateEstablishment.fulfilled, (state, action) => {
			state.itemEstablishmentList = state.itemEstablishmentList.map(establishment =>
				establishment.establishmentname === action.payload.old_establishment
					? { ...establishment, ...action.payload.updated_establishment }
					: establishment
			);
			state.establishmentList = state.establishmentList.map(establishment =>
				establishment._id.toString() === action.payload._id.toString()
					? { ...establishment, ...action.payload }
					: establishment
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updateEstablishment.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateEstablishment.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteEstablishment.fulfilled, (state, action) => {
			state.itemEstablishmentList = current(state.itemEstablishmentList).filter(
				item => item._id !== action.payload._id
			);
			state.establishmentList = current(state.establishmentList).filter(item =>
				item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deleteEstablishment.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deleteEstablishment.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});

		builder.addCase(getProductiveCycleActive.fulfilled, (state, action) => {
			state.isEstablishmentLoading = false;
			state.isEstablishmentSuccess = true;
			state.productiveCycleActiveDetail = action.payload;
			state.isLoadingList = false;
			
			state.isLoading = false;
			state.isSuccess = true;
		});
		builder.addCase(getProductiveCycleActive.pending, state => {
			state.isEstablishmentLoading = true;
			state.isEstablishmentSuccess = null;
			state.error = null;
			state.isLoadingList = true;
			
			state.isLoading = true;
			state.isSuccess = false;
			state.error = null;
		});
		builder.addCase(getProductiveCycleActive.rejected, (state, action) => {
			state.isEstablishmentLoading = false;
			state.isEstablishmentSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
			
			state.isLoading = false;
			state.isSuccess = false;
			state.isError = true;
			state.error = action.error.message;
		});
	},
});

export const { setRequireCloseModal } = EstablishmentSlice.actions;

export default EstablishmentSlice.reducer;
